// @flow

import React, { Component } from 'react';

import App from './App.jsx';

import {SIDEBAR_WIDTH} from './consts.js';

import './css/Indicator.css';


type T_Pos = {
  top : number,
  left: number
};


type T_IndicatorProps = {
  active_map       : number,
  show_tree        : boolean,
  width            : number,
  height           : number,
  show_dialog_user : boolean,
  show_dialog_tools: boolean,
  full_height      : boolean,
  app              : App
};



// ESTA CLASE DEFINE EL TRIÁNGULO QUE INDICA EL MAPA ACTIVO CUANDO LA PANTALLA SE DIVIDE EN CUATRO

export default class Indicator extends Component<T_IndicatorProps> {
  get_active_pos(): T_Pos {
    const {active_map, width, height, show_tree, show_dialog_user, show_dialog_tools, full_height} = this.props,
          offset = SIDEBAR_WIDTH,
          WIDTH  = ((width - offset) / 2) + 8,
          HEIGHT = ((height - (full_height ? 0 : 40)) * 0.5) + 10;
    
    const active_positions = [    // posiciones del triangulo rojo. Indica qué mapa está activo.
      {top: 10    , left: 10},
      {top: 10    , left:  WIDTH},
      {top: HEIGHT, left: 10},
      {top: HEIGHT, left:  WIDTH}
    ];
    
    if (active_map === 0 && show_tree) {
      active_positions[active_map].left = 295;
      
      return active_positions[active_map];
    }
    else if (active_map !== 2) {
      return active_positions[active_map];
    }
    else {
      const rpos = active_positions[active_map];
      
      if (show_tree) {
        rpos.left = 295;
      }
      
      if (show_dialog_user) {
        rpos.left = 295;
      }
      
      if (show_dialog_tools) {
        rpos.left = 335;
      }
      
      return rpos;
    }
  }
  
  
  
  render() {
    if (this.props.active_map < 0) {
      return null;
    }
    
    return (
      <img
        alt=''
        src='./img/redMark.png'
        className='active_map'
        style={this.get_active_pos()}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Indicator.jsx